import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9272c530"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "AdditionalServices" }
const _hoisted_2 = { class: "AdditionalServices__title" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "AdditionalServices__form-ltl mt-3" }
const _hoisted_5 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-6 items-center" }
const _hoisted_6 = { class: "grid grid-cols-2 gap-3 items-center" }
const _hoisted_7 = { class: "grid grid-cols-2 gap-3 items-center" }
const _hoisted_8 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-6 items-center mt-3" }
const _hoisted_9 = { class: "grid grid-cols-2 gap-3 items-center" }
const _hoisted_10 = { class: "grid grid-cols-2 gap-3 items-center" }
const _hoisted_11 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-6 items-center mt-3" }
const _hoisted_12 = { class: "grid grid-cols-2 gap-3 items-center" }
const _hoisted_13 = { class: "grid grid-cols-1 lg:grid-cols-3 gap-6 items-center mt-3" }
const _hoisted_14 = { class: "mt-3 flex items-center" }
const _hoisted_15 = { class: "AdditionalServices__holder" }
const _hoisted_16 = { class: "AdditionalServices__actions" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      (!_ctx.setted)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.waypointName)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" Укажите дополнительные услуги (" + _toDisplayString(_ctx.waypointName) + ") ", 1)
                ], 64))
              : (_ctx.isReceiver)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode("Укажите дополнительные услуги получателя")
                  ], 64))
                : (_ctx.isSender)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createTextVNode("Укажите дополнительные услуги отправителя")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _createTextVNode(" Укажите дополнительные услуги "),
                      (_ctx.isAdditionalServicesVisible)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "(при заборе)"))
                        : _createCommentVNode("", true)
                    ], 64))
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.waypointName)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode("Дополнительные услуги (" + _toDisplayString(_ctx.waypointName) + ")", 1)
                ], 64))
              : (_ctx.isReceiver)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode("Дополнительные услуги получателя")
                  ], 64))
                : (_ctx.isSender)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createTextVNode("Дополнительные услуги отправителя")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _createTextVNode("Дополнительные услуги")
                    ], 64))
          ], 64))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.isLtlEdit)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_checkbox, {
                  label: "Авто",
                  value: _ctx.state.hasCar,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.hasCar) = $event)),
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.state_ltl.carCost = null))
                }, null, 8, ["value"]),
                _createVNode(_component_the_input, {
                  value: _ctx.state_ltl.carCost,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state_ltl.carCost) = $event)),
                  placeholder: "Стоимость машины",
                  disabled: !_ctx.state.hasCar,
                  "is-invalid": _ctx.state_form$.carCost.$error,
                  "validation-errors": _ctx.state_form$.carCost.$errors
                }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_checkbox, {
                  label: "Манипулятор",
                  value: _ctx.state.hasManipulator,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.hasManipulator) = $event)),
                  onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.state_ltl.manipulatorCost = null))
                }, null, 8, ["value"]),
                _createVNode(_component_the_input, {
                  value: _ctx.state_ltl.manipulatorCost,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state_ltl.manipulatorCost) = $event)),
                  placeholder: "Стоимость манипулятора",
                  disabled: !_ctx.state.hasManipulator,
                  "is-invalid": _ctx.state_form$.manipulatorCost.$error,
                  "validation-errors": _ctx.state_form$.manipulatorCost.$errors
                }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_checkbox, {
                  label: "Кран",
                  value: _ctx.state.hasCrane,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.hasCrane) = $event)),
                  onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.state_ltl.craneCost = null))
                }, null, 8, ["value"]),
                _createVNode(_component_the_input, {
                  value: _ctx.state_ltl.craneCost,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state_ltl.craneCost) = $event)),
                  placeholder: "Стоимость крана",
                  disabled: !_ctx.state.hasCrane,
                  "is-invalid": _ctx.state_form$.craneCost.$error,
                  "validation-errors": _ctx.state_form$.craneCost.$errors
                }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_checkbox, {
                  label: "Рохля",
                  value: _ctx.state.hasHydraulicTrolley,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.hasHydraulicTrolley) = $event)),
                  onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.state_ltl.hydraulicTrolleyCost = null))
                }, null, 8, ["value"]),
                _createVNode(_component_the_input, {
                  value: _ctx.state_ltl.hydraulicTrolleyCost,
                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state_ltl.hydraulicTrolleyCost) = $event)),
                  placeholder: "Стоимость рохли",
                  disabled: !_ctx.state.hasHydraulicTrolley,
                  "is-invalid": _ctx.state_form$.hydraulicTrolleyCost.$error,
                  "validation-errors": _ctx.state_form$.hydraulicTrolleyCost.$errors
                }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_checkbox, {
                  label: "Паллета",
                  value: _ctx.state.hasPallet,
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.hasPallet) = $event)),
                  onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.state_ltl.palletCost = null))
                }, null, 8, ["value"]),
                _createVNode(_component_the_input, {
                  value: _ctx.state_ltl.palletCost,
                  "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state_ltl.palletCost) = $event)),
                  placeholder: "Стоимость паллеты",
                  disabled: !_ctx.state.hasPallet,
                  "is-invalid": _ctx.state_form$.palletCost.$error,
                  "validation-errors": _ctx.state_form$.palletCost.$errors
                }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_checkbox, {
                label: "Грузчики",
                value: _ctx.state.hasLoader,
                "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.hasLoader) = $event)),
                onChange: _ctx.onHasLoaderChange
              }, null, 8, ["value", "onChange"]),
              _createVNode(_component_the_input, {
                value: _ctx.state_ltl.amountOfLoaders,
                "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state_ltl.amountOfLoaders) = $event)),
                placeholder: "Количество грузчиков",
                disabled: !_ctx.state.hasLoader,
                "is-invalid": _ctx.state_form$.amountOfLoaders.$error,
                "validation-errors": _ctx.state_form$.amountOfLoaders.$errors
              }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
              _createVNode(_component_the_input, {
                value: _ctx.state_ltl.hoursOfLoadersWork,
                "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state_ltl.hoursOfLoadersWork) = $event)),
                placeholder: "Количество часов работы грузчиков",
                disabled: !_ctx.state.hasLoader,
                "is-invalid": _ctx.state_form$.hoursOfLoadersWork.$error,
                "validation-errors": _ctx.state_form$.hoursOfLoadersWork.$errors
              }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_checkbox, {
                label: "Обрешетка",
                value: _ctx.state.hasGrid,
                "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.hasGrid) = $event))
              }, null, 8, ["value"]),
              _createVNode(_component_checkbox, {
                class: "ml-3",
                label: "Мягкая упаковка",
                value: _ctx.state.hasSoftPackage,
                "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.hasSoftPackage) = $event))
              }, null, 8, ["value"])
            ])
          ], 64))
        : (!_ctx.setted && !_ctx.disabled)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_checkbox, {
                label: "Авто",
                value: _ctx.state.hasCar,
                "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.hasCar) = $event))
              }, null, 8, ["value"]),
              _createVNode(_component_checkbox, {
                label: "Мягкая упаковка",
                value: _ctx.state.hasSoftPackage,
                "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.state.hasSoftPackage) = $event))
              }, null, 8, ["value"]),
              _createVNode(_component_checkbox, {
                label: "Манипулятор",
                value: _ctx.state.hasManipulator,
                "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.state.hasManipulator) = $event))
              }, null, 8, ["value"]),
              _createVNode(_component_checkbox, {
                label: "Кран",
                value: _ctx.state.hasCrane,
                "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.state.hasCrane) = $event))
              }, null, 8, ["value"]),
              _createVNode(_component_checkbox, {
                label: "Рохля",
                value: _ctx.state.hasHydraulicTrolley,
                "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.state.hasHydraulicTrolley) = $event))
              }, null, 8, ["value"]),
              _createVNode(_component_checkbox, {
                label: "Обрешетка",
                value: _ctx.state.hasGrid,
                "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.state.hasGrid) = $event))
              }, null, 8, ["value"]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_checkbox, {
                  label: "Грузчики",
                  value: _ctx.state.hasLoader,
                  "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.state.hasLoader) = $event)),
                  class: "mr-3"
                }, null, 8, ["value"]),
                (_ctx.state.hasLoader)
                  ? (_openBlock(), _createBlock(_component_the_input, {
                      key: 0,
                      class: "ml-3",
                      placeholder: "Количество",
                      value: _ctx.state_ftl.loader_value,
                      "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.state_ftl.loader_value) = $event)),
                      "is-invalid": _ctx.state_ftl$.loader_value.$error,
                      "validation-errors": _ctx.state_ftl$.loader_value.$errors
                    }, null, 8, ["value", "is-invalid", "validation-errors"]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_checkbox, {
                label: "Паллета",
                value: _ctx.state.hasPallet,
                "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.state.hasPallet) = $event))
              }, null, 8, ["value"])
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("span", null, "Авто: " + _toDisplayString(_ctx.state.hasCar ? 'Да' : 'Нет'), 1),
              _createElementVNode("span", null, "Мягкая упаковка: " + _toDisplayString(_ctx.state.hasSoftPackage ? 'Да' : 'Нет'), 1),
              _createElementVNode("span", null, "Манипулятор: " + _toDisplayString(_ctx.state.hasManipulator ? 'Да' : 'Нет'), 1),
              _createElementVNode("span", null, "Кран: " + _toDisplayString(_ctx.state.hasCrane ? 'Да' : 'Нет'), 1),
              _createElementVNode("span", null, "Рохля: " + _toDisplayString(_ctx.state.hasHydraulicTrolley ? 'Да' : 'Нет'), 1),
              _createElementVNode("span", null, "Обрешетка: " + _toDisplayString(_ctx.state.hasGrid ? 'Да' : 'Нет'), 1),
              _createElementVNode("span", null, "Грузчики: " + _toDisplayString(_ctx.state.hasLoader ? 'Да' : 'Нет'), 1),
              _createElementVNode("span", null, "Паллета: " + _toDisplayString(_ctx.state.hasPallet ? 'Да' : 'Нет'), 1)
            ], 64))
    ]),
    _createElementVNode("div", _hoisted_16, [
      (!_ctx.disabled)
        ? (_openBlock(), _createBlock(_component_the_button, {
            key: 0,
            class: _normalizeClass(["second small text px-3 py-2", { 'mr-4': !_ctx.setted }]),
            onClick: _ctx.emitReset
          }, {
            default: _withCtx(() => [
              _hoisted_17,
              _createTextVNode(" Сбросить ")
            ]),
            _: 1
          }, 8, ["class", "onClick"]))
        : _createCommentVNode("", true),
      (!_ctx.setted && !_ctx.disabled)
        ? (_openBlock(), _createBlock(_component_the_button, {
            key: 1,
            loading: _ctx.loading,
            class: "primary small px-3 py-2",
            onClick: _ctx.emitSubmit
          }, {
            default: _withCtx(() => [
              _hoisted_18,
              _createTextVNode(" Подтвердить ")
            ]),
            _: 1
          }, 8, ["loading", "onClick"]))
        : _createCommentVNode("", true)
    ])
  ]))
}